module.exports = __webpack_public_path__ + "img/macos-3-tw.0ea82f6d.png";